module.exports = __webpack_public_path__ + "img/logo-fullclean-top.384e0a02.png";